<template>
  <v-data-table
    :items="securities"
    :headers="headers"
    hide-default-footer
    disable-pagination
  >
    <template #item.actions="{ item, index }">
      <v-tooltip top>
        <template #activator="{ on }">
          <v-btn
            v-on="on"
            class="mr-2"
            color="#8990AD"
            icon
            @click="editSecurity(index, item)"
          >
            <v-icon v-text="'mdi-pencil'" />
          </v-btn>
        </template>
        <span>{{ $t('general_edit_label') }}</span>
      </v-tooltip>
      <v-tooltip top>
        <template #activator="{ on }">
          <v-btn
            v-on="on"
            icon
            color="#8990AD"
            @click="removeSecurity(index, item)"
          >
            <v-icon v-text="'mdi-delete'" />
          </v-btn>
        </template>
        <span>{{ $t('general_delete_label') }}</span>
      </v-tooltip>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'SecurityTable',
  props: {
    securities: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      headers: [
        { text: this.$t('general_isin_code'), value: 'isin' },
        { text: this.$t('general_name'), value: 'name' },
        { text: this.$t('general_quantity'), value: 'quantity', align: 'end' },
        {
          text: this.$t('general_actions_label'),
          value: 'actions',
          width: '140px',
          maxWidth: '140px',
          align: 'center'
        }
      ]
    }
  },
  methods: {
    removeSecurity(index, item) {
      this.$emit('remove', { index, item })
    },
    editSecurity(index, item) {
      this.$emit('edit', { index, item })
    }
  }
}
</script>
